var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useLayoutEffect } from "react";
import useAsync from "react-use/lib/useAsync";
export var StreamConnectionState;
(function (StreamConnectionState) {
    StreamConnectionState[StreamConnectionState["Disconnected"] = 0] = "Disconnected";
    StreamConnectionState[StreamConnectionState["Ready"] = 1] = "Ready";
    StreamConnectionState[StreamConnectionState["Connecting"] = 2] = "Connecting";
    StreamConnectionState[StreamConnectionState["ConnectionError"] = 3] = "ConnectionError";
    StreamConnectionState[StreamConnectionState["ChangingMode"] = 4] = "ChangingMode";
})(StreamConnectionState || (StreamConnectionState = {}));
export const ZLBoltContext = React.createContext(undefined);
export const ZLBoltOptionsContext = React.createContext(undefined);
export const ZLBoltStreamStateContext = React.createContext(StreamConnectionState.Disconnected);
export function ZLBolt(props) {
    const zlbolt = useAsync(() => __awaiter(this, void 0, void 0, function* () { return props.zlbolt instanceof Promise ? yield props.zlbolt : props.zlbolt; }), [props.zlbolt]);
    const options = useAsync(() => __awaiter(this, void 0, void 0, function* () { return props.options instanceof Promise ? yield props.options : props.options; }), [props.options]);
    function disconnect() {
        var _a;
        (_a = zlbolt.value) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    useEffect(() => disconnect, [zlbolt.value, options.value]);
    useEffect(() => {
        (props.connect && zlbolt.value && options.value) ? zlbolt.value.connect(options.value) : undefined;
    }, [zlbolt.value, options.value, props.connect]);
    useLayoutEffect(() => {
        const bolt = zlbolt.value;
        return bolt ?
            (window.addEventListener("beforeunload", disconnect),
                () => window.removeEventListener("beforeunload", disconnect)) : undefined;
    }, [zlbolt.value]);
    return React.createElement(ZLBoltContext.Provider, { value: zlbolt.value },
        React.createElement(ZLBoltOptionsContext.Provider, { value: options.value },
            React.createElement(ZLBoltStreamState, null, props.children)));
}
export function ZLBoltStreamState(props) {
    const zlbolt = useZLBolt();
    const [ready, setReady] = React.useState(StreamConnectionState.Disconnected);
    function onReady() {
        setReady(StreamConnectionState.Ready);
    }
    function onDisconnect() {
        setReady(StreamConnectionState.Disconnected);
    }
    function onConnect() {
        setReady(StreamConnectionState.Connecting);
    }
    function onConnectionError() {
        setReady(StreamConnectionState.ConnectionError);
    }
    function onModeChange(mode, status) {
        if (status === "pending")
            setReady(StreamConnectionState.ChangingMode);
        if (status === "success")
            setReady(StreamConnectionState.Ready);
        if (status === "error")
            setReady(StreamConnectionState.ConnectionError);
    }
    React.useEffect(() => {
        zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.addEventListener("streamReady", onReady);
        zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.addEventListener("streamDisconnect", onDisconnect);
        zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.addEventListener("streamConnect", onConnect);
        zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.addEventListener("streamConnectFailed", onConnectionError);
        zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.addEventListener("modeChange", onModeChange);
        return () => {
            zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.removeEventListener("streamReady", onReady);
            zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.removeEventListener("streamDisconnect", onDisconnect);
            zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.removeEventListener("streamConnect", onConnect);
            zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.removeEventListener("streamConnectFailed", onConnectionError);
            zlbolt === null || zlbolt === void 0 ? void 0 : zlbolt.removeEventListener("modeChange", onModeChange);
        };
    }, [zlbolt]);
    return React.createElement(ZLBoltStreamStateContext.Provider, { value: ready }, props.children);
}
export function useZLBolt() {
    return useContext(ZLBoltContext);
}
export function useZLBoltOptions() {
    return useContext(ZLBoltOptionsContext);
}
export function useZLBoltStreamState() {
    return useContext(ZLBoltStreamStateContext);
}
